<template>
	<div class="jobinfo">
		<div class="jobinfo-title">
			<span style="font-size: 18px;font-weight: bold;">{{campusjobinfo.positionName}}</span>
		</div>
		<div class="jobinfo-table">
			<el-table :data="infoNewList" style="width: 100%" border :header-cell-style="{ textAlign: 'center' }"
				:span-method="objectSpanMethod" :cell-style="cellStyle">
				<el-table-column prop="name" width="100">
				</el-table-column>
				<el-table-column label="招聘要求">
					<template slot-scope="scope">
						<div class="white-space-pre-line" v-html="scope.row.requirements"></div>
					</template>
				</el-table-column>
				<el-table-column prop="responsibilities" label="岗位职责">
				</el-table-column>
				<el-table-column prop="number" label="招聘人数" width="100">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="180">
					<template slot-scope="scope">
						<el-button @click="requestPosition()" type="text" size="small">立即投递</el-button>
						<el-button @click="collectionjob()" type="text" size="small">收藏岗位</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <el-collapse v-model="activeName" accordion>
			<el-collapse-item name="1" class="test">
				<template slot="title">
					<div class="temtitle">
						<div class="jobname">{{campusjobinfo.positionName}}</div> -->
		<!-- <div class="info"> -->
		<!-- 							<span>
								<img src="../image/department.png" />
								招聘单位：{{campusjobinfo.department}}
							</span>
							<span class="divider">|</span>
							<span>
								<img src="../image/position.png" />
								工作地点：{{campusjobinfo.base}}
							</span>
							<span class="divider">|</span>
							<span>
								<img src="../image/time.png" />
								发布时间：{{campusjobinfo.updateTime}}
							</span> -->
		<!-- </div> -->
		<!-- </div>
				</template>
				<div class="detailedinfo">
					<div class="responsibilities"> -->
		<!-- <span style="font-size: 18px;">工作职责：<br /></span> -->
		<!-- <span style="font-size: 18px;">招聘条件：<br /></span>
						<span class="custom"
							style="white-space: pre-wrap;">{{campusjobinfo.responsibilities}}<br /></span>
					</div> -->
		<!-- <div class="qualification">
						<span style="font-size: 18px;">任职资格：<br /></span>
						<span class="custom">{{campusjobinfo.requirements}}</span>
					</div> -->
		<!-- <div class="contacts">
						<span style="font-size: 14px;">联系人：<br /></span>
						<span class="custom">{{campusjobinfo.contact}}</span>
					</div> -->
		<!-- <el-button @click="handresume()" type="primary" class="handbtn">立即投递</el-button> -->
		<!-- <el-button @click="requestPosition()" type="primary" class="handbtn">立即投递</el-button>
					<el-button @click="collectionjob()" class="collectionbtn" icon="el-icon-star-off">收藏岗位</el-button>
				</div>
			</el-collapse-item>
		</el-collapse> -->
		<el-dialog title="投递确认" :visible.sync="requestOrderDialog" width="30%">
			<el-radio-group v-model="order">
				<!-- <el-radio label="0">第一志愿</el-radio> -->
				<!-- <el-radio label="1">第二志愿</el-radio> -->
			</el-radio-group>
			<span slot="footer" class="dialog-footer">
				<el-button @click="requestOrderDialog = false">取 消</el-button>
				<el-button type="primary" @click="requestPosition()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				order: 0,
				requestOrderDialog: false,
				activeName: '',
				transferpositionID: {
					positionID: '',
					type: 0,
					order: 0,
				},
				infoNewList: [{
					name: '学历要求：',
					responsibilities: '',
					number: '',
					requirements: '',
				}, {
					name: '专业要求：',
					responsibilities: '',
					number: '',
					requirements: '',
				}, {
					name: '政治面貌：',
					responsibilities: '',
					number: '',
					requirements: '',
				}, {
					name: '其他要求：',
					responsibilities: '',
					number: '',
					requirements: '',
				}],
			};
		},
		props: {
			campusjobinfo: {}
		},
		mounted() {
			this.infoChange()
		},
		methods: {
			infoChange() {
				let responsibilitiesAll = this.campusjobinfo.responsibilities.substring(0, this.campusjobinfo
					.responsibilities.lastIndexOf("招聘人数："))

				let responsibilitiesLast = responsibilitiesAll.substring(responsibilitiesAll.lastIndexOf("："))
				responsibilitiesLast = responsibilitiesLast.slice(1)

				let responsibilitiesOther = this.campusjobinfo.responsibilities.substring(this.campusjobinfo
					.responsibilities.lastIndexOf("招聘人数："))

				let numberAll = responsibilitiesOther.substring(0, responsibilitiesOther.lastIndexOf("学历要求："))

				let numberLast = numberAll.substring(numberAll.lastIndexOf("："))
				numberLast = numberLast.slice(1)

				let requirements = responsibilitiesOther.substring(responsibilitiesOther.lastIndexOf("学历要求："))

				let a = requirements.substring(0, requirements.lastIndexOf("专业要求："))
				let aAll = requirements.substring(requirements.lastIndexOf("专业要求："))
				let b = aAll.substring(0, aAll.lastIndexOf("政治面貌："))
				let bAll = aAll.substring(aAll.lastIndexOf("政治面貌："))
				let c = bAll.substring(0, bAll.lastIndexOf("其他要求："))
				let cAll = bAll.substring(bAll.lastIndexOf("其他要求："))

				this.infoNewList[0].responsibilities = responsibilitiesLast
				this.infoNewList[0].number = numberLast
				a = a.slice(5)
				b = b.slice(5)
				c = c.slice(5)
				cAll = cAll.slice(5)
				this.infoNewList[0].requirements = a
				this.infoNewList[1].requirements = b
				this.infoNewList[2].requirements = c
				this.infoNewList[3].requirements = cAll

				console.log(this.infoNewList[0], this.infoNewList[1], this.infoNewList[2], this.infoNewList[3])
			},

			cellStyle(column) {
				if (column.columnIndex === 2) {
					return "padding-left: 55px"
				}
				if (column.columnIndex === 3 || column.columnIndex === 4) {
					return "text-align:center;"
				}

			},

			collectionjob() {
				this.transferpositionID.type = 0;
				this.$emit('transferpositionID', this.transferpositionID)
			},
			requestPosition() {
				this.transferpositionID.order = 0
				// this.transferpositionID.order = this.order
				this.transferpositionID.type = 1;
				this.transferpositionID.positionID = this.campusjobinfo.positionID
				this.$emit('transferpositionID', this.transferpositionID)
				// this.requestOrderDialog = false
			},
			handresume() {
				this.requestOrderDialog = true;
			},

			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 4) {
					return {
						rowspan: 4,
						colspan: 1
					}
				}
				if (columnIndex === 3) {
					return {
						rowspan: 4,
						colspan: 1
					}
				}
				if (columnIndex === 2) {
					return {
						rowspan: 4,
						colspan: 1
					}
				}
				// if (columnIndex === 0) {
				// 	if (rowIndex % 2 === 0) {
				// 		return {
				// 			rowspan: 2,
				// 			colspan: 1
				// 		};
				// 	} else {
				// 		return {
				// 			rowspan: 0,
				// 			colspan: 0
				// 		};
				// 	}
				// }
			},
		},
	}
</script>

<style lang="scss" scoped>
	.jobinfo-table {

		::v-deep .el-table td.el-table__cell,
		.el-table th.el-table__cell.is-leaf {
			border-bottom: 1px solid transparent;
		}

		::v-deep .el-table--border,
		.el-table--group {

			border: 1px solid transparent;
		}

		::v-deep .el-table--border .el-table__cell,
		.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
			border-right: 10px solid transparent;
			// border-left: 10px solid transparent;
		}

	}

	.jobinfo {
		padding: 20px 30px;

		.el-collapse {
			border: none !important;
		}

		::v-deep .el-collapse-item__header {
			height: 80px !important;
			border: none !important;
		}
	}


	.jobname {
		color: #333;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.info {
		display: flex;
		align-items: center;


	}

	.img {
		width: 24px;
		height: 24px;
	}

	.divider {
		margin-left: 15px;
		margin-right: 15px;
	}

	.detailedinfo {
		padding-top: 20px;
	}

	.responsibilities {
		margin-top: 35px;
	}

	.contacts {
		margin-top: 35px;
	}

	.qualification {
		margin-top: 35px;
	}

	.white-space-pre-line {
		white-space: pre-line;
	}

	.custom {
		margin-top: 30px;
		font-size: 14px;
		line-height: 1.5;
	}

	.handbtn {
		width: 140px;
		height: 50px;
		font-size: 16px;
		margin-top: 35px;
		margin-right: 25px;
	}

	.collectionbtn {
		width: 140px;
		height: 50px;
		font-size: 16px;
	}
</style>
